import React, { useState, useRef, useContext } from "react";
import { RegisterSuccessProvider } from "../context/RegisterSuccessful";

const Otp = () => {
  const [otp, setOtp] = useState(new Array(5).fill(""));
  const inputRefs = useRef([]);
  const { successMessage } = useContext(RegisterSuccessProvider);
  const [displayMessage, setDisplayMessage] = useState(false);
  const [responseFromBackend, setResponseFromBackend] = useState("");

  // Handle change in the input field
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return; // Ensure only numbers are allowed
    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    // Move to the next input if a value is entered
    if (element.value && index < 4) {
      inputRefs.current[index + 1].focus();
    }
  };

  // Handle backspace key to go to previous input
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  // Handle pasting the OTP
  const handlePaste = (e) => {
    const pastedData = e.clipboardData.getData("text").split("");
    if (pastedData.length === 5 && pastedData.every((char) => !isNaN(char))) {
      setOtp(pastedData);
      pastedData.forEach((char, index) => {
        inputRefs.current[index].value = char;
      });
      inputRefs.current[4].focus();
    }
    e.preventDefault();
  };

  const submit = () => {
   
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      otp: otp.join(''),
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch("http://localhost:4000/otp", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        console.log(result);
        setResponseFromBackend(successMessage);
        console.log(successMessage);
        setDisplayMessage(true)
      })
      .catch((error) => console.error(error));
  };
 

  return (
    <div className="w-full flex justify-center items-center flex-col gap-11">
      <div onPaste={handlePaste} className="flex gap-[10px]">
        {otp.map((data, index) => (
          <input
            key={index}
            type="text"
            maxLength="1"
            className="w-24 h-16 border-solid border-2 rounded text-center "
            value={data}
            onChange={(e) => handleChange(e.target, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            ref={(el) => (inputRefs.current[index] = el)}
          />
        ))}
      </div>
      <p className={displayMessage?"block text-base text-white":"hidden"}>{responseFromBackend}</p>
      <button className="bg-[#01FF00] p-3 rounded" onClick={submit}>
        Submit
      </button>
    </div>
  );
};

export default Otp;
